import {AfterViewInit, Component} from '@angular/core';
import {TranslocoService} from "@ngneat/transloco";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {animate, style, transition, trigger} from "@angular/animations";
import {StoreSelectorsService} from "../../../services";
import {ToastrService} from "ngx-toastr";
import {ICart, ICartCreate, ICartProduct, IUser} from "../../../interfaces";
import {LocalStoreService} from "../../../services/local-store.service";
import {UserService} from "../../../services/user.service";
import {isCartEmpty, isProductInUrl} from "../../../common";
import {Compbaser} from "../../../components/compbaser";

@Component({
    selector: 'app-cart-nav',
    styleUrls: [`./cart-nav.component.scss`],
    templateUrl: './cart-nav.component.html',
    animations: [
        trigger(
            'inOutAnimation',
            [
                transition(
                    ':enter',
                    [
                        style({height: 0, opacity: 0}),
                        animate('1s ease-out',
                            style({height: 150, opacity: 1}))
                    ]
                ),
                transition(
                    ':leave',
                    [
                        style({height: 150, opacity: 1}),
                        animate('1s ease-in',
                            style({height: 0, opacity: 0}))
                    ]
                )
            ]
        )
    ]
})
export class CartNavsComponent extends Compbaser implements AfterViewInit {
    cartProducts: Array<ICartProduct>;
    navigationEnd: NavigationEnd;
    cartCreate: ICartCreate;
    addedProduct: string = null;
    user: IUser;
    cart: ICart;
    selected: string;
    standaloneMode = false;

    constructor(private translocoService: TranslocoService, private localStoreService: LocalStoreService, private userService: UserService,
                private router: Router, private route: ActivatedRoute, private storeSelector: StoreSelectorsService, private toastr: ToastrService) {
        super();
        this.cod(
            this.storeSelector.getUser().subscribe((v) => {
                this.user = v;
            })
        );
        this.cod(
            this.storeSelector.getCart().subscribe((v) => {
                this.cart = v;
            })
        );
        this.cod(
            this.router.events.subscribe((e) => {
                if (e instanceof NavigationEnd) {
                    this.navigationEnd = e;
                    if (this.navigationEnd.url.indexOf('shopping-cart') > -1) this.standaloneMode = true;
                    if (this.navigationEnd.url.match('products')) this.selected = 'products';
                    if (this.navigationEnd.url.match('list')) this.selected = 'list';
                    if (this.navigationEnd.url.match('checkout')) this.selected = 'checkout';
                }
            })
        );
    }

    ngAfterViewInit() {
    }

    navigateTo(link) {
        switch (link) {
            case 'products': {
                const routeTo = isProductInUrl(this.navigationEnd) ? '../../products' : '../products';
                this.router.navigate([routeTo], {relativeTo: this.route});
                break;
            }
            case 'cart': {
                const routeTo = isProductInUrl(this.navigationEnd) ? '../../list' : '../list';
                this.router.navigate([routeTo], {relativeTo: this.route});
                break;
            }
            case 'checkout': {
                if (isCartEmpty(this.cart)) {
                    this.toastr.info(this.translocoService.translate('toast.pleaseReviewCartFirst3', {}, this.translocoService.getActiveLang()));
                    const routeToList = isProductInUrl(this.navigationEnd) ? '../../list' : '../list';
                    this.router.navigate([routeToList], {relativeTo: this.route});
                    return;
                }
                if (!this.cart.cartLocation) return this.toastr.error(this.translocoService.translate('toast.noShippingCart', {}, this.translocoService.getActiveLang()));
                const routeTo = isProductInUrl(this.navigationEnd) ? '../../checkout' : '../checkout';
                this.router.navigate([routeTo], {relativeTo: this.route});
                break;
            }
        }
    }
}
